import { Provider } from "@angular/core";

/**
 * service/tokens
 */
import {
  AUTH_API_LOGIN,
  AUTH_API_LOGOUT,
  AUTH_API_GET_NEW_TOKEN,
  AUTH_API_SESSION_MANAGEMENT,
  AUTH_API_FORGOT_PASSWORD,
  AUTH_API_RESET_PASSWORD,
  AUTH_API_CHECK_RESET_TOKEN,
} from "./auth-api-tokens";
import {
  AuthenticationApiService
} from "../authentication-api.service";

/**
 * Array of Angular providers for authentication API services
 * @constant {Provider[]} AuthenticationApiServiceProviders
 * @description Configures dependency injection for all authentication API services and tokens.
 * The AuthenticationApiService is provided as the implementation for all authentication API interfaces.
 * 
 * @example
 * ```typescript
 * // In your module or component
 * providers: [...AuthenticationApiServiceProviders]
 * 
 * // Or inject specific services
 * constructor(@Inject(AUTH_API_LOGIN) private authLogin: IAuthLoginApi) {}
 * constructor(@Inject(AUTH_API_LOGOUT) private authLogout: IAuthLogoutApi) {}
 * constructor(@Inject(AUTH_API_GET_NEW_TOKEN) private authGetNewToken: IAuthGetNewTokenApi) {}
 * constructor(@Inject(AUTH_API_SESSION_MANAGEMENT) private authSessionManagement: IAuthSessionManagementApi) {}
 * ```
 */
export const AuthenticationApiServiceProviders: Provider[] = [
  AuthenticationApiService,
  { provide: AUTH_API_LOGIN, useExisting: AuthenticationApiService },
  { provide: AUTH_API_LOGOUT, useExisting: AuthenticationApiService },
  { provide: AUTH_API_GET_NEW_TOKEN, useExisting: AuthenticationApiService },
  { provide: AUTH_API_SESSION_MANAGEMENT, useExisting: AuthenticationApiService },
  { provide: AUTH_API_FORGOT_PASSWORD, useExisting: AuthenticationApiService },
  { provide: AUTH_API_RESET_PASSWORD, useExisting: AuthenticationApiService },
  { provide: AUTH_API_CHECK_RESET_TOKEN, useExisting: AuthenticationApiService },
];